import { ValidateEmail } from "@swivl-mono/helpers";
import { Button, ButtonColor, ButtonSize, Input } from "@swivl-mono/ui";
import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import AccountModel from "../../../Models/Account/AccountModel";
import { AlertsModel } from "../../../Models/Notifications/Alerts.Model";
import Logo from "../Assets/SwivlLogo.png";

export function ForgotPasswordView() {
  const navigate = useNavigate();
  const [queryParams, setQueryParams] = useSearchParams();
  const [username, setUsername] = useState(queryParams?.get("email") ?? "");
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const recoverAccount = () => {
    const validEmail = ValidateEmail(username.toLowerCase());
    if (validEmail === false) {
      setIsLoading(true);
      setErrorMsg("Please enter a valid email");
      return;
    }
    setIsLoading(true);
    setErrorMsg("");
    try {
      AccountModel.forgotPassword(username).then((response) => {
        setIsLoading(false);
        AlertsModel.successToast("Instructions to reset your password have been sent to your email address");
        navigate("/login?email=" + username);
      });
    } catch (error) {
      setIsLoading(false);
      setErrorMsg("An error occurred while processing your request. Please try again later.");
    }
  };

  return (
    <div className="mx-auto flex max-w-[290px] flex-col items-center">
      <img src={Logo} alt="Swivl Logo" className="mx-auto mb-8 w-[145px]" />
      <div className="container mx-auto">
        <div className="flex flex-col">
          <h1 className="mb-5 text-center text-lg">Forgot Password</h1>

          <div className="mb-5 text-center text-sm text-gray-900">
            Enter the email address associated with your swivl Studio account and we'll send you instructions on how to reset your password.
          </div>

          <Input
            label="Email Address"
            value={username}
            name="username"
            type="email"
            autoComplete="email"
            containerClassName="mb-4"
            onChange={(e) => setUsername(e.target.value)}
          />

          <Button className="mb-5 w-full" onClick={recoverAccount} loading={isLoading} color={ButtonColor.ORANGE} size={ButtonSize.LARGE}>
            Submit
          </Button>

          <Link className="mx-auto" to="/login">
            Back
          </Link>
        </div>
      </div>
      <div className="errorMsg">{errorMsg}</div>
    </div>
  );
}
